import { ObjectF } from "./object";
import { Variable } from "./variable";


export class FormulaConfiguration {

    id: number = 0;
    variable: Variable = new Variable();
    object: ObjectF = new ObjectF();
    description!: string;
    formula!: string;
    active: boolean = false;

    //benefitDivisionAreaList: BenefitDivisionArea[] = [];
    
}